import {
	Box,
	CardContent,
	Dialog,
	Stack,
	Typography,
} from "@mui/material";
import { useState } from "react";

import { isDesktop } from "react-device-detect";
import { useTranslation } from "react-i18next";
import { ReactComponent as CheckmarkIcon } from "../../Assets/Icons/Checkmark.svg";
import { ReactComponent as Ended } from "../../Assets/Icons/Ended.svg";
import { ReactComponent as EndingSoon } from "../../Assets/Icons/EndingSoon.svg";
import { ReactComponent as PendingIcon } from "../../Assets/Icons/Pending.svg";
import { ColorScheme } from "../../Themes/ColorScheme";
import TooltipWrapper from "../Common/TooltipWrapper";
import { DoorAccessEdit } from "./DoorAccessEdit";

function getStatusProperty(start, end, property, restricted) {
	const { t } = useTranslation();
	const checkStatus = () => {
		// todo improve this and make it reusable component

		const now = new Date().getTime();
		const startDate = new Date(start).getTime();
		const endDate = new Date(end).getTime();

		if (!restricted) {
			return 0; // ongoing
		} else if (now < startDate)
			return 1; // not started
		else if (endDate < now) {
			return 2; // ended
		} else {
			return 0; // ongoing
		}
	};

	if (property === "main") {
		if (!restricted) return ColorScheme.successPrimary;
		else
			switch (checkStatus()) {
				case 0:
					return ColorScheme.successPrimary;
				case 1:
					return ColorScheme.warningPrimary;
				case 2:
					return ColorScheme.dangerPrimary;
				default:
					return ColorScheme.successPrimary;
			}
	} else if (property === "secondary") {
		if (!restricted) return ColorScheme.successSecondary;
		else
			switch (checkStatus()) {
				case 0:
					return ColorScheme.successSecondary;
				case 1:
					return ColorScheme.warningSecondary;
				case 2:
					return ColorScheme.dangerSecondary;
				default:
					return ColorScheme.successSecondary;
			}
	} else if (property === "icon") {
			switch (checkStatus()) {
				case 0:
					return (
						<CheckmarkIcon
							stroke={ColorScheme.successPrimary}
							strokeWidth={2}
							width={"20px"}
							height={"20px"}
						/>
					);
				case 1:
					return (
						<EndingSoon
							stroke={ColorScheme.warningPrimary}
							strokeWidth={2}
							width={"24px"}
							height={"24px"}
						/>
					);
				case 2:
					return (
						<Ended
							stroke={ColorScheme.dangerPrimary}
							strokeWidth={2}
							width={"24px"}
							height={"24px"}
						/>
					);
				default:
					return (
						<PendingIcon
							stroke={ColorScheme.successPrimary}
							strokeWidth={2}
							width={"24px"}
							height={"24px"}
						/>
					);
			}
	} else if (property === "text") {
		if (!restricted) return t("key.ongoing");
		else
			switch (checkStatus()) {
				case 0:
					return !isDesktop ? "" : t("key.ongoing");
				case 1:
					return !isDesktop ? "" : t("key.not_started");
				case 2:
					return !isDesktop ? "" : t("key.not_valid");

				default:
					return !isDesktop ? "" : t("key.ongoing");
			}
	}
}

export const DoorUser = ({ access, refreshUserList }) => {

	const restricted = access.restrict_times;

	const { t } = useTranslation();

	const [hover, setHover] = useState(false);

	const [openDialog, setOpenDialog] = useState(false);

	const closeDialog = () => {
		setOpenDialog(false);
		refreshUserList();
	};

	return (
		<div onMouseEnter={() => setHover(true)}
		onMouseLeave={() => setHover(false)} style={{ position: "relative", cursor: "pointer",
			backgroundColor: hover ? ColorScheme.secondary : "transparent"
		 }} onClick={() => !openDialog && setOpenDialog(true)}>
			<Dialog open={openDialog} onClose={() => setOpenDialog(false)}>
				<DoorAccessEdit
					data={access}
					handleClick={() => setOpenDialog(false)}
					refreshUserList={refreshUserList}
					closeDialog={closeDialog}
				/>
			</Dialog>

			<Stack
				direction="row"
				justifyContent="space-between"
				alignItems="center"
				sx={{ padding: "20px", gap: "40px", borderBottom: "1px solid " + ColorScheme.darkGrey + ColorScheme.opacity10 }}
			>
				<CardContent
					sx={{
						width: "calc(100% - 60px)",
						height: "100%",
						alignContent: "center",
						alignItems: "center",
						justifyContent: "center",
						padding: 0,
					}}
				>
					<Stack>
						<Stack direction="row" gap="10px">
							<Stack
								direction={"column"}
								sx={{
									justifyContent: "center",
									alignItems: "flex-start",
									flex: 1,
								}}
							>
								{(access?.user?.name !== "" || access?.user?.email !== "") ? (
									<>
									<Typography
										fontSize={"18px"}
										fontWeight={"700"}
									>
										{access?.user?.name || ""}
									</Typography>
									<Typography
										fontSize={
											access?.user?.name === undefined ||
											access?.user?.name === ""
												? "18px"
												: "12px"
										}
										color={
											access?.user?.name === undefined ||
											access?.user?.name === ""
												? undefined
												: ColorScheme.textSecondary
										}
										fontWeight={"700"}
									>
										{access?.user?.email || ""}
									</Typography>
									</>
								)
								: (
									<>
									<Typography
										fontSize={"18px"}
										fontWeight={"700"}
									>
										{access?.user?.phone || ""}
									</Typography>
									<Typography
										fontSize={
											access?.user?.phone === undefined ||
											access?.user?.phone === ""
												? "18px"
												: "12px"
										}
										color={
											access?.user?.phone === undefined ||
											access?.user?.phone === ""
												? undefined
												: ColorScheme.textSecondary
										}
										fontWeight={"700"}
									>
										{access?.user?.license_plate || ""}
									</Typography>
									</>
								)}
									{!isDesktop && access.pin_code !== "" && (
										<Typography
											fontSize={"12px"}
											color={ColorScheme.textSecondary}
											fontWeight={"700"}
										>
											{
												t("doors.pin_code_label") +
												": " +
												access.pin_code
											}
										</Typography>
									)}
							</Stack>
							<Stack
								sx={{
									justifyContent: "center",
									alignItems: "end",
								}}
							>
								{isDesktop &&
									access.pin_code !== "" &&
									access.pin_code !== null &&
									access.pin_code !== undefined && (
										<Box
											sx={{
												alignItems: "center",
												borderRadius: "4px",
												px: "8px",
												py: "3px",
												display: "flex",
												justifyContent: "center",
												width: "80px",
												alignSelf: "end"
											}}
										>
											<Typography
												sx={{
													fontSize: "14px",
													fontWeight: "700",
													color: ColorScheme.textSecondary
												}}
											>
												{t("doors.pin_code_label") +
													": " +
													access.pin_code}
											</Typography>
										</Box>
									)}
							</Stack>
						</Stack>
					</Stack>
				</CardContent>

				<div
					style={{
						maxWidth: "40px",
						minWidth: "40px",
						right: "20px",
						borderRadius: "20px"
					}}
				>
					<TooltipWrapper
						title={getStatusProperty(
							access.access_starts_at,
							access.access_ends_at,
							"text",
							restricted
						)}
						placement="top"
					>
						<div
							style={{
								minHeight: "40px",
								left: "0px",
								minWidth: "40px",
								display: "flex",
								justifyContent: "center",
								alignItems: "center",
								backgroundColor: getStatusProperty(
									access.access_starts_at,
									access.access_ends_at,
									"secondary",
									restricted
								),
								borderRadius: "20px",
							}}
						>
							{getStatusProperty(
								access.access_starts_at,
								access.access_ends_at,
								"icon",
								restricted
							)}
						</div>
					</TooltipWrapper>
				</div>
			</Stack>
		</div>
	);
};
